import React from "react";

type SizeButtonProps = {
    isSelected?: boolean;
    isCoupon?: boolean;
    text: string;
    onClick: () => void;
};

const SizeButton = React.forwardRef<HTMLButtonElement, SizeButtonProps>(
    ({ isSelected = false, isCoupon, text, onClick }, ref) => {
        return (
            <button
                // prettier-ignore
                className={`${isSelected ? "md:border-black text-black border-2" : "border-gray"} rounded-[4px] relative h-[32px] border w-fit px-2 py-2
          ${text === "One Size" ? " leading-[12px]" : ""} ${isCoupon ? "" : ""}
          text-black flex items-center justify-center text-base-16  whitespace-nowrap`}
                onClick={onClick}
                ref={ref}
            >
                {text}
            </button>
        );
    }
);

export default SizeButton;
